// frontend/src/hooks/useDemoMode.ts
// Demo mode: when ?demo=true is in the URL, mock/placeholder data is shown.
// Otherwise, only real backend data is used.

import { useMemo } from 'react';

export function useDemoMode(): boolean {
  return useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('demo') === 'true';
  }, []);
}
